import React from 'react';
import { BaseButton } from '../../BaseButton/BaseButton';
import ButtonGroup, { ButtonGroupProps } from '@material-ui/core/ButtonGroup';
import { makeStyles } from '@material-ui/core';
import clsx from 'clsx';

type TValue = number | string;
type TLabel = string | React.ElementType;

export type PMenuTabs = Pick<ButtonGroupProps, 'orientation' | 'className'> & {
  onChange: (value: TValue) => void;
  value: TValue;
  tabs: Array<{ value: TValue; label: TLabel; isActive?: boolean }>;
};

const useStyles = makeStyles((theme) => ({
  root_horizontal: {},
  root_vertical: {
    width: '100%',
    // boxShadow: '0 8px 30px rgba(108, 108, 108, 0.15)',
  },
  btn_horizontal: {
    // boxShadow: '0 8px 30px rgba(108, 108, 108, 0.15)',
    maxHeight: '40px',
    border: 0,
    padding: '8px 25px',
    background: '#F3F4F6',
    color: '#000000',
    fontWeight: 500,
    '&:first-child': {
      borderRadius: '8px 0px 0px 8px',
    },
    '&:last-child': {
      borderRadius: '0px 8px 8px 0px',
    },
    '&:not(:last-child)': {
      marginRight: '5px',
    },
    [theme.breakpoints.up('sm')]: {
      padding: '8px 12px',
      fontSize: '14px'
    },
  },
  btn_vertical: {
    width: '100%',
    height: '40px',
    border: 0,
    fontWeight: 500,
    '&:first-child': {
      borderRadius: '8px 8px 0px 0px',
    },
    '&:last-child': {
      borderRadius: '0 0 8px 8px',
    },
  },
  primary: {
    background: '#7AC5F1',
    color: 'white',
    boxShadow: 'none',
    '&:hover': {
      opacity: 1,
      background: '#7AC5F1',
      boxShadow: 'none'
    },
  },
}));

export const MenuTabs: React.FC<PMenuTabs> = (props) => {
  const {
    onChange,
    value,
    tabs,
    orientation = 'horizontal',
    className,
    ...otherProps
  } = props;
  const classes = useStyles({ orientation });
  return (
    <ButtonGroup
      orientation={orientation}
      {...otherProps}
      className={clsx(
        orientation === 'horizontal'
          ? classes.root_horizontal
          : classes.root_vertical,
        className,
      )}
    >
      {tabs.map((btn: any) => {
        const btnVariant =
          btn.isActive || value === btn.value ? 'contained' : 'outlined';
        return (
          <BaseButton
            className={clsx(
              orientation === 'horizontal'
                ? classes.btn_horizontal
                : classes.btn_vertical,
              btnVariant === 'contained' && classes.primary,
            )}
            key={btn.value}
            variant={btnVariant}
            onClick={() => onChange(btn.value)}
          >
            {btn.label}
          </BaseButton>
        );
      })}
    </ButtonGroup>
  );
};
